<template>
    <div>
        <form class="mb-0" ref="form" :data-url='`crm/deal/note/sync/${this.props.id}`'>
         <app-input type="text-editor" :required="true" v-model="formData.note"/>

            <div class="pt-primary px-primary border-top mx-minus-primary">
                <button type="button" class="btn btn-primary mr-1" @click.prevent="submitData">{{ $t('save') }}</button>
                <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('cancel') }}</button>
            </div>
        </form>
    </div>
</template>

<script>

    import {FormMixin} from "@core/mixins/form/FormMixin";

    export default {
        name: "NoteTab",
        mixins: [FormMixin],
        props:['props'],
        data() {
            return {
                formData:{}
            }
        },
        methods:{
            submitData(){
                this.save(this.formData);
            },
            afterError(response) {
                this.$toastr.e(response.data.message);
            },

            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('activity-list', 'note');
                this.formData.note = ''
            },
            cancel(){
                location.reload();
            }
        }
    }
</script>
